var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { BigNumber, ethers } from 'ethers';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, FctValueListN } from '../../../../Fct/generics/FctParams';
import { FaWater } from 'react-icons/fa';
import { getLPTokenFromPool, supportedPools } from '../helpers/supportedContracts';
export var AddLiquidity = createPlugin({
    protocol: 'CURVE',
    type: 'ACTION',
    method: 'add_liquidity',
    name: 'addLiquidity',
    description: 'Deposit coins into the pool',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'curve_pool',
                    options: supportedPools.filter(function (pool) { return pool.chainId === Number(chainId); }),
                    isPreview: true,
                }),
                poolLPToken: new FctAddress({
                    destination: 'curve_pool',
                    readonly: true,
                }),
                poolGaugeToken: new FctAddress({
                    destination: 'curve_gauge',
                    readonly: true,
                }),
                value: new FctValue({ readonly: true, required: false }),
                amount1: new FctValue({ isPreview: true, icon: FaWater }),
                amount2: new FctValue({ isPreview: true, icon: FaWater }),
                amount3: new FctValue({ isPreview: true, icon: FaWater }),
                amount4: new FctValue({ isPreview: true }),
                methodParams: {
                    amounts: new FctValueListN({ readonly: true }),
                    minMintAmount: new FctValue({ destination: 'wei_amount', required: false, decimals: 18 }),
                },
            },
            output: {},
        });
    },
    initParams: {
        methodParams: {
            minMintAmount: '0',
        },
    },
    overrideSetMethodParams: function (_a) {
        var input = _a.input;
        return function (params) {
            var _a;
            Object.keys(input.methodParams).forEach(function (key, i) {
                var paramKey = key;
                input.methodParams[paramKey].value = params[i];
            });
            (_a = input.methodParams.amounts.value) === null || _a === void 0 ? void 0 : _a.forEach(function (value, i) {
                input["amount".concat(i)].value = value;
            });
        };
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input;
        var to = input.to, methodParams = input.methodParams, poolLPToken = input.poolLPToken, poolGaugeToken = input.poolGaugeToken;
        var getParams = function () { return __awaiter(void 0, void 0, void 0, function () {
            var defaultReturn, pool, i, label;
            return __generator(this, function (_a) {
                defaultReturn = {
                    poolLPToken: undefined,
                    poolGaugeToken: undefined,
                    value: undefined,
                    amount1: undefined,
                    amount2: undefined,
                    amount3: undefined,
                    amount4: undefined,
                    methodParams: {
                        amounts: undefined,
                        minMintAmount: '0',
                    },
                };
                if (!to.value || typeof to.value !== 'string') {
                    return [2 /*return*/, {
                            params: defaultReturn,
                            error: undefined,
                        }];
                }
                pool = to.options.find(function (p) { return p.address === to.value; });
                if (!pool)
                    return [2 /*return*/, {
                            params: defaultReturn,
                            error: undefined,
                        }];
                methodParams.amounts.value = [];
                poolLPToken.value = pool.lpTokenAddress;
                poolLPToken.decimals = 18;
                poolLPToken.label = "Curve LP ".concat(pool.symbol);
                poolGaugeToken.value = pool.gaugeAddress;
                poolGaugeToken.decimals = 18;
                poolGaugeToken.label = "Curve Gauge ".concat(pool.symbol);
                pool.coins.forEach(function (coin, index) {
                    var label = "amount".concat(index + 1);
                    if (!input[label])
                        return;
                    input[label].decimals = Number(coin.decimals);
                    input[label].label = coin.symbol;
                    if (!methodParams.amounts.value)
                        return;
                    input[label].hidden = false;
                    input[label].readonly = false;
                    input[label].required = true;
                    // if (input[label].value && typeof input[label].value === 'string') {
                    //   methodParams.amounts.value.push(input[label].value)
                    // }
                });
                for (i = 1; i < 5; i++) {
                    if (i <= pool.coins.length)
                        continue;
                    label = "amount".concat(i);
                    if (!input[label])
                        continue;
                    input[label].hidden = true;
                    input[label].readonly = true;
                    input[label].required = false;
                    input[label].decimals = 0;
                }
                if (pool.assetTypeName === 'eth' && pool.coins[0].symbol === 'ETH') {
                    return [2 /*return*/, {
                            params: {
                                value: input.amount1.value || '0',
                                receiveLPToken: pool.lpTokenAddress,
                                receivedGaugeToken: pool.gaugeAddress,
                                methodParams: {
                                    amounts: methodParams.amounts.value,
                                },
                            },
                            error: undefined,
                        }];
                }
                return [2 /*return*/, {
                        params: {
                            value: '0',
                            poolLPToken: pool.lpTokenAddress,
                            poolGaugeToken: pool.gaugeAddress,
                            methodParams: {
                                amounts: methodParams.amounts.value,
                            },
                        },
                        error: undefined,
                    }];
            });
        }); };
        return { get: getParams, depParamKeys: ['to', 'amount1', 'amount2', 'amount3', 'amount4'] };
    },
    requiredApprovals: function (params) {
        var pool = supportedPools.find(function (p) { return p.address === params.to.value; });
        if (!pool)
            return [];
        if (pool.assetTypeName === 'eth' && pool.coins[0].symbol === 'ETH') {
            if (!pool.coins[1])
                return [];
            if (typeof (params === null || params === void 0 ? void 0 : params.amount2.value) === 'string' && BigNumber.from(params === null || params === void 0 ? void 0 : params.amount2.value).lte('0'))
                return [];
            return [
                {
                    to: pool.coins[1].address,
                    params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.amount2.value },
                    method: 'approve',
                    protocol: 'ERC20',
                },
            ];
        }
        var approvals = [];
        pool.coins.forEach(function (coin, index) {
            var label = "amount".concat(index + 1);
            if (!params[label])
                return;
            if (typeof params[label].value === 'string' && BigNumber.from(params[label].value).lte('0'))
                return;
            approvals.push({
                to: coin.address,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params[label].value },
                method: 'approve',
                protocol: 'ERC20',
            });
        });
        return approvals;
    },
    // onCreate: ({ input }) => {
    //   const setAmount = (amountNumber: "1" | "2" | "3" | "4") => {
    //     const amountsValue = input.methodParams.amounts.value || []
    //     const amountLabel = `amount${amountNumber}` as const
    //     const inputAmount = input[amountLabel]
    //     const amountIndex = Number(amountNumber) - 1
    //     if(inputAmount.hidden) {
    //       const amounts = amountsValue.slice(0, amountIndex)
    //       input.methodParams.amounts.set({ value: amounts })
    //       return
    //     }
    //     amountsValue[amountIndex] = inputAmount.value || '0'
    //     input.methodParams.amounts.set({ value: amountsValue })
    //   }
    //   input.amount1.subscribe({
    //     callback: () => {
    //       setAmount('1')
    //     },
    //     id: 'set amount1',
    //   })
    //   input.amount2.subscribe({
    //     callback: () => {
    //       setAmount('2')
    //     },
    //     id: 'set amount2',
    //   })
    //   input.amount3.subscribe({
    //     callback: () => {
    //       setAmount('3')
    //     },
    //     id: 'set amount3',
    //   })
    //   input.amount4.subscribe({
    //     callback: () => {
    //       setAmount('4')
    //     },
    //     id: 'set amount4',
    //   })
    //   setAmount('1')
    //   setAmount('2')
    //   setAmount('3')
    //   setAmount('4')
    // },
    // getSubscribtions: ({}) => [
    //   {
    //     callback: (params) => {
    //       if (!params) return
    //       const input = params
    //       const setAmount = (amountNumber: '1' | '2' | '3' | '4') => {
    //         const amountsValue = input.methodParams.amounts.value || []
    //         const amountLabel = `amount${amountNumber}` as const
    //         const inputAmount = input[amountLabel]
    //         const amountIndex = Number(amountNumber) - 1
    //         if (inputAmount.hidden) {
    //           const amounts = amountsValue.slice(0, amountIndex)
    //           input.methodParams.amounts.setQuiet({ value: amounts })
    //           return
    //         }
    //         amountsValue[amountIndex] = inputAmount.value
    //         input.methodParams.amounts.setQuiet({ value: amountsValue })
    //         if (amountNumber !== '1') return
    //         if (params.amount1.label === 'ETH') {
    //           params.value.setQuiet({ value: inputAmount.value })
    //           return
    //         }
    //         params.value.setQuiet({ value: '0' })
    //         return
    //       }
    //       setAmount('1')
    //       setAmount('2')
    //       setAmount('3')
    //       setAmount('4')
    //       return
    //     },
    //     id: 'set_amounts_array',
    //   },
    // ],
    assetFlow: function (params, chainId, walletAddress, vaultAddress, provider, method) {
        return __awaiter(this, void 0, void 0, function () {
            var to, pool, toSpend, lpTokenAddress, toReceive, PoolContract, lpTokenAmount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        to = params.to;
                        pool = to.options.find(function (p) { return p.address === to.value; });
                        if (!pool || !to.value || !vaultAddress)
                            return [2 /*return*/, []];
                        if (typeof to.value !== 'string')
                            return [2 /*return*/, []];
                        toSpend = [];
                        pool.coins.forEach(function (coin, index) {
                            var label = "amount".concat(index + 1);
                            if (!params[label])
                                return;
                            if (typeof params[label].value === 'string' && BigNumber.from(params[label].value).lte('0'))
                                return;
                            toSpend.push({
                                token: coin.address,
                                amount: params[label].value,
                            });
                        });
                        lpTokenAddress = getLPTokenFromPool(chainId, to.value);
                        toReceive = [];
                        if (!lpTokenAddress) return [3 /*break*/, 2];
                        PoolContract = new ethers.Contract(to.value, [
                            "function calc_token_amount(uint256[".concat(pool.coins.length, "] amounts, bool deposit) external view returns(uint256)"),
                        ], provider);
                        return [4 /*yield*/, PoolContract.calc_token_amount(toSpend.map(function (s) { return s.amount; }), true)];
                    case 1:
                        lpTokenAmount = _a.sent();
                        toReceive.push({
                            token: lpTokenAddress,
                            amount: lpTokenAmount,
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/, [
                            {
                                address: vaultAddress,
                                toSpend: toSpend,
                                toReceive: toReceive,
                            },
                        ]];
                }
            });
        });
    },
});
